<template>
  <div class="row">
    <!-- Start Single Service  -->

    <v-col
      xl="8"
      lg="8"
      md="7"
      sm="7"
      cols="12"
      class="mt--25 mb--10 mt_sm--0 mt_md--0"
    >
      <!-- <h2>Βαθμίδες και προνόμια</h2>
      <p style="line-height: 1.5">Με την κάρτα Health_e Bonus απολαμβάνετε ξεχωριστά προνόμια σε όλα τα θεραπευτήρια
      και διαγνωστικά κέντρα του Ομίλου. Με κάθε σας συναλλαγή, μαζεύετε πόντους, Health_e Bonus
      ανεβαίνετε βαθμίδα, και ανταμείβεστε για την εμπιστοσύνη σας στην οικογένεια HHG</p> -->
      <h2>Σας καλωσορίζουμε στο loyalty program του HHG</h2>
      <p style="font-size: 20px">
        Είμαστε ο μεγαλύτερος ιδιωτικός όμιλος υπηρεσιών υγείας στην Ελλάδα. Στο
        Hellenic Healthcare Group, με έξι κορυφαία θεραπευτήρια (Υγεία,
        Metropolitan Hospital, Μητέρα, Metropolitan General, Λητώ και Creta
        Interclinic) και τέσσερα διαγνωστικά κέντρα (HealthSpot) παρέχουμε
        ολοκληρωμένη ιατρική περίθαλψη 24 ώρες το 24ωρο, 365 ημέρες το χρόνο. Το
        HHG σας επιβραβεύει για την εμπιστοσύνη σας και, αξιοποιώντας τις νέες
        τεχνολογίες, δημιουργεί την εφαρμογή Health_e Bonus Card. Μέσα από την
        εφαρμογή αποκτάτε την ψηφιακή κάρτα και απολαμβάνετε ξεχωριστά προνόμια
        στα θεραπευτήρια και τα διαγνωστικά κέντρα του Ομίλου. Με κάθε σας
        συναλλαγή, συλλέγετε πόντους και ανταμείβεστε με περισσότερες παροχές
        και μοναδικές προσφορές.
      </p>
      <v-row>
        <v-col md="5" lg="4" xl="3" cols="6">
          <router-link to="/privileges">
            <img
              :src="pictureHover"
              @mouseover="hover = true"
              @mouseleave="hover = false"
            />
          </router-link>
        </v-col>
        <v-col md="5" lg="4" xl="3" cols="6">
          <router-link to="/privileges">
            <img
              :src="pictureHover1"
              @mouseover="hover1 = true"
              @mouseleave="hover1 = false"
            />
          </router-link>
        </v-col>
      </v-row>
    </v-col>

    <v-col
      xl="3"
      lg="3"
      md="4"
      sm="4"
      cols="12"
      class="mt--60 mt_sm--5 mt_md--60 d-none d-sm-block"
    >
      <div class="d-flex flex-row">
        <v-img
          contain
          alt=""
          src="../../assets/images/bg/phone.png"
          position="absolute"
        />
      </div>
    </v-col>
    <v-col xl="1" lg="1" md="1" sm="1" cols="12"> </v-col>
    <!-- End Single Service  -->
  </div>
</template>

<script>
import feather from "feather-icons";
export default {
  data() {
    return {
      pictureStatic: require("../../assets/images/home/butt1_black.png"),
      pictureStatic1: require("../../assets/images/home/butt2_black.png"),
      pictureGif: require("../../assets/images/home/butt1_red.png"),
      pictureGif1: require("../../assets/images/home/butt2_red.png"),
      hover: false,
      hover1: false,
    };
  },
  computed: {
    pictureHover() {
      if (this.hover == true) {
        return this.pictureGif;
      } else {
        return this.pictureStatic;
      }
    },
    pictureHover1() {
      if (this.hover1 == true) {
        return this.pictureGif1;
      } else {
        return this.pictureStatic1;
      }
    },
  },
};
</script>
<style scoped>
h2 {
  font-family: "PFBagueSansPro-Bold";
}
p {
  font-family: "PFBagueSansPro-Light";
}

@media only screen and (max-width: 767px) {
  .theme--light.v-image {
    overflow: visible;
    margin-top: -200px;
    margin-left: 58px;
    float: right;
  }
  .v-responsive {
    position: relative;
    overflow: hidden;
    flex: 1 0 auto;
    max-width: 128%;
    display: flex;
  }
}

h2 {
  font-family: "PFBagueSansPro-Bold";
  font-size: 40px !important;
}
.backgroung-grey {
  background-color: #e6e6e7;
}
/* @media only screen and (max-width: 1630px) {
  h2 {
    font-size: 40px !important;
  }
}
@media only screen and (max-width: 1350px) {
  h2 {
    font-size: 35px !important;
  }
} */
@media only screen and (max-width: 769px) {
  h2 {
    font-size: 22px !important;
  }
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  .theme--light.v-image {
    overflow: visible;
    margin-top: -347px;
    margin-left: 58px;
    float: right;
  }
  .v-responsive {
    position: relative;
    overflow: hidden;
    flex: 1 0 auto;
    max-width: 128%;
    display: flex;
  }
}

@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .theme--light.v-image {
    overflow: visible;
    margin-top: -506px;
    margin-left: 43px;
    float: right;
  }
  .v-responsive {
    position: relative;
    overflow: hidden;
    flex: 1 0 auto;
    max-width: 115%;
    display: flex;
  }
}

@media only screen and (min-width: 1200px) and (max-width: 1263px) {
  .theme--light.v-image {
    overflow: visible;
    margin-top: -513px;
    margin-left: 131px;
    float: right;
  }
  .v-responsive {
    position: relative;
    overflow: hidden;
    flex: 1 0 auto;
    max-width: 100%;
    display: flex;
  }
}

@media only screen and (min-width: 1264px) and (max-width: 1550px) {
  .theme--light.v-image {
    overflow: visible;
    margin-top: -520px;
    margin-left: 28px;
    float: right;
  }
  .v-responsive {
    position: relative;
    overflow: hidden;
    flex: 1 0 auto;
    max-width: 133%;
    display: flex;
  }
}

@media only screen and (min-width: 1551px) {
  .theme--light.v-image {
    overflow: visible;
    margin-top: -520px;
    margin-left: 71px;
    float: right;
  }
  .v-responsive {
    position: relative;
    overflow: hidden;
    flex: 1 0 auto;
    max-width: 110%;
    display: flex;
  }
}
</style>
